import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Brand from "@/components/common/Brand";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsletterUnsubscribePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    (async () => {
      if (!token) { setStatus("error"); return; }
      try {
        const { data } = await axios.post(`${API}/api/newsletter/unsubscribe`, { token });
        setEmail(data.email || "");
        setStatus("ok");
      } catch {
        setStatus("error");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="newsletter-unsubscribe-page">
      <div className="h-14 bg-[#0A0A0A] flex items-center justify-center px-4">
        <Brand className="text-xl" />
      </div>
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center max-w-md mx-auto">
        {status === "loading" && (
          <div className="flex items-center gap-2 text-[#666]"><Loader2 size={18} className="animate-spin" /> Einen Moment…</div>
        )}
        {status === "ok" && (
          <div data-testid="newsletter-unsub-ok">
            <CheckCircle2 size={40} className="text-green-600 mx-auto" />
            <h1 className="text-xl font-bold text-[#0A0A0A] mt-4">Du bist abgemeldet</h1>
            <p className="text-sm text-[#666] mt-2">
              {email ? <>Die Adresse <strong>{email}</strong> erhält</> : "Du erhältst"} keine Newsletter mehr von uns.
              Du kannst den Newsletter jederzeit in deinem Profil unter „Sicherheit" wieder aktivieren.
            </p>
            <button onClick={() => navigate("/")} className="mt-6 h-11 px-6 rounded-full bg-[#0A0A0A] text-white text-sm font-medium hover:bg-[#222]" data-testid="newsletter-unsub-home">
              Zur Startseite
            </button>
          </div>
        )}
        {status === "error" && (
          <div data-testid="newsletter-unsub-error">
            <XCircle size={40} className="text-red-500 mx-auto" />
            <h1 className="text-xl font-bold text-[#0A0A0A] mt-4">Link ungültig</h1>
            <p className="text-sm text-[#666] mt-2">Dieser Abmelde-Link ist ungültig oder wurde bereits verwendet. Du kannst den Newsletter in deinem Profil unter „Sicherheit" verwalten.</p>
            <button onClick={() => navigate("/")} className="mt-6 h-11 px-6 rounded-full bg-[#0A0A0A] text-white text-sm font-medium hover:bg-[#222]">
              Zur Startseite
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
